<template>
    <div>
        <div class="card">
            <div class="card-header">
                <div class="card-title m-0">
                    <h3 class="card-label">
                        {{ __('reservations.settings') }}
                    </h3>
                    <p class="m-0">
                        {{ __('reservations.settings_description') }}
                    </p>
                </div>
            </div>

            <div class="card-body">
                <table class="table table-hover">
                    <thead>
                    <tr>
                        <th>{{ __('general.store') }}</th>
                        <th>{{ __('general.status') }}</th>
                        <th class="text-right">{{ __('general.actions') }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="store in stores">
                        <td>
                            <Store :store="store" />
                        </td>
                        <td class="h-2em">
                            <Center class="h-100" vertical>
                                <div>
                                    <Badge v-if="store.reservations_enabled" type="badge-success" icon="fas fa-check">
                                        {{ __('general.thing.enabled', {thing: __('general.reservation')}) }}
                                    </Badge>
                                    <Badge v-else icon="fas fa-times">
                                        {{ __('general.thing.disabled', {thing: __('general.reservation')}) }}
                                    </Badge>
                                </div>
                            </Center>
                        </td>
                        <td class="h-2em text-right">
                            <Center class="h-100" vertical>
                                <div>
                                    <div class="btn-group btn-group-sm">
                                        <Link as="button"
                                              :href="$route('store.edit.reservations', [store.id])"
                                              class="btn btn-sm btn-light-primary">
                                            <i class="fas fa-edit mr-1"/>
                                            {{ __('actions.edit_thing', {thing: __('general.settings')}) }}
                                        </Link>
                                        <Link as="button"
                                              :href="$route('orders.index.store', {storeUuid: store.id, tab: 'done'})"
                                              class="btn btn-sm btn-light-info">
                                            <i class="fas fa-arrow-circle-right mr-1"/>
                                            {{ __('general.reservations') }}
                                        </Link>
                                    </div>
                                </div>
                            </Center>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import StoreAddress from "@components/Store/StoreAddress.vue";
import Badge from "@components/Badge.vue";
import { Link } from '@inertiajs/vue2';
import Alert from "@components/Alert.vue";
import Center from "@components/Layout/Center.vue";
import StoreImage from "@components/Store/StoreImage.vue";
import Store from "@components/Store/Store.vue";

export default {
    components: {Store, StoreImage, Center, Alert, Badge, StoreAddress, Link},

    props: {
        stores: Array
    }
}
</script>
